export * from './addresses'
export * from './escapeRegExp'
export * from './getContract'

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}

export const currentTimestamp = () => new Date().getTime()
